import React from "react";
import { CreatePageFinalizeState } from "./CreatePageFinalizeState";
import { CreatePageRegionSelectorState } from "./CreatePageRegionSelectorState";

type Param = {
  /**
   * The text content of the button.
   */
  text: string;

  /**
   * The result of `useRegionSelectorState()`.
   */
  regionSelectorState: CreatePageRegionSelectorState;

  /**
   * The result of `useFinalizeState()`.
   */
  finalizeState: CreatePageFinalizeState;

  /**
   * Whether the button should be disabled. Ignored when the `submitting` param is true.
   */
  disabled: boolean;

  /**
   * Where the form is submitting. If this is true then nothing else matters.
   */
  submitting: boolean;
};

export type ButtonState = {
  type: "disabled" | "enabled" | "submitting";
  text: string;
};

export const useButtonState = (param: Param): ButtonState => {
  const { text, submitting, disabled, regionSelectorState, finalizeState } = param;

  return React.useMemo(() => {
    if (submitting) {
      return { type: "submitting", text };
    }

    if (disabled || regionSelectorState.valid === false || finalizeState.valid === false) {
      return { type: "disabled", text };
    }

    return { type: "enabled", text };
  }, [text, submitting, disabled, finalizeState.valid]);
};
